<script>
export default {
  name: "f-menu",
};
</script>

<template>
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 56.36 42.38"
  >
    <g id="FL_Online">
      <g>
        <g>
          <circle class="cls-2" cx="17.61" cy="10.86" r="10.86" />
          <path
            class="cls-2"
            d="m29.79,42.38H5.44c-3.49,0-6.07-3.24-5.3-6.64,1.85-8.13,6.77-12.55,9.07-14.22,2.31,1.83,5.23,2.92,8.41,2.92s6.09-1.1,8.41-2.92c2.3,1.67,7.22,6.09,9.07,14.22.77,3.4-1.81,6.64-5.3,6.64Z"
          />
        </g>
        <rect
          class="cls-1"
          x="30.08"
          y="0"
          width="26.28"
          height="4.21"
          rx="2.11"
          ry="2.11"
        />
        <rect
          class="cls-1"
          x="34.89"
          y="12.72"
          width="21.48"
          height="4.21"
          rx="2.11"
          ry="2.11"
        />
        <rect
          class="cls-1"
          x="40.49"
          y="25.45"
          width="15.87"
          height="4.21"
          rx="2.11"
          ry="2.11"
        />
      </g>
    </g>
  </svg>
</template>

<style scoped lang="scss">
.cls-1 {
  fill: #fff;
}

.cls-1,
.cls-2 {
  stroke-width: 0px;
}

.cls-2 {
  fill: #ffc713;
}
</style>
